// import React, {useEffect,useState} from "react";
// import { useLocation } from "react-router-dom";
// import { useQuery,useQueryClient } from "@tanstack/react-query";
// import { useMemo } from "react";
// import AppointmentListService from "./Services/AppointmentListService";

// const PatientSettings =() => {
//   const queryClient = useQueryClient();
//   const location = useLocation();
//   const patientId = location.state?.patientId;
//     useEffect(() => {
//                 const scriptUrls = [
//                   "assets/js/jquery-3.7.1.min.js",
//                   "assets/js/bootstrap.bundle.min.js",
//                   "assets/plugins/select2/js/select2.min.js",
//                   "assets/js/moment.min.js",
//                   "assets/js/bootstrap-datetimepicker.min.js",
//                   "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
//                   "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
//                   "assets/js/script.js"
//                 ];
            
//                 let isCancelled = false;
            
//                 const loadScriptsSequentially = async () => {
//                   for (const url of scriptUrls) {
//                     if (isCancelled) break;
            
//                     await new Promise((resolve, reject) => {
//                       const script = document.createElement('script');
//                       script.src = url;
//                       script.async = false;
//                       script.onload = () => {
//                         console.log(`Loaded: ${url}`);
//                         resolve();
//                       };
//                       script.onerror = () => {
//                         console.error(`Failed to load: ${url}`);
//                         reject();
//                       };
//                       document.body.appendChild(script);
//                     });
//                   }
            
//                   // Now init plugins after scripts are loaded
//                   if (!isCancelled) {
//                     // if (window.AOS) {
//                     //   window.AOS.init();
//                     // }
            
//                     if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
//                       window.$('.datetimepicker').datetimepicker();
//                     }
            
//                     if (typeof window.initBackToTop === 'function') {
//                       window.initBackToTop(); // assuming your backToTop script defines this
//                     }
            
//                     console.log('All scripts loaded and initialized.');
//                   }
//                 };
            
//                 loadScriptsSequentially();
            
//                 return () => {
//                   isCancelled = true;
//                 };
//               }, []);

//   const updatedBy= localStorage.getItem('userId');
//   const through = localStorage.getItem('userType');

// // Query for Patients that created by user.
// const { data: patientData, isLoading: isLoadingPatient } = useQuery({
//   queryKey: ['patientDataReports'],
//   queryFn: async () => {
//     const response = await AppointmentListService.getPatientByPatientId(patientId); // Limit to 5
//     return response;
//   },
// });
// const patientDataReports = useMemo(
//   () => patientData?.data?.data ?? {},
//   [patientData]
// );

//  const [patientName, setPatientName] = useState('');
// const [gender, setGender] = useState('');
// const [phone, setPhone] = useState('');
// const [age, setAge] = useState('');
// const [dob, setDob] = useState('');
// const [email, setEmail] = useState('');
// const [pincode, setPincode] = useState('');
// const [city, setCity] = useState('');
// const [address, setAddress] = useState('');
// // const formatDob = (dateStr) => {
// //   if (!dateStr) return '';
// //   const [year, month, day] = dateStr.split('-');
// //   return `${day}-${month}-${year}`;
// // };
//  useEffect(() => {
//   if (patientDataReports) {
//     setPatientName(patientDataReports.patientName || '');
//     setGender(patientDataReports.gender || '');
//     setPhone(patientDataReports.phone || '');
//     setAge(patientDataReports.age || '');
//     setDob((patientDataReports.dob) || '');
//     setEmail(patientDataReports.email || '');
//     setPincode(patientDataReports.pincode || '');
//     setCity(patientDataReports.city || '');
//     setAddress(patientDataReports.address || '');
//   }
// }, [patientDataReports]);
//  const handleSubmit = async (e) => {
//     // Prevent default form submission
//     e.preventDefault();
//     const payLoad ={
//   patientName: patientName,
//   gender: gender,
//   phone: phone,
//   age: age,
//   dob: dob,
//   address: address,
//   city:city,
//   pincode:pincode,
//   email:email,
//   through: through,
//   updatedBy: updatedBy,
//     }
//     const response =  await AppointmentListService.changePatientDetails(patientId,payLoad);
//     console.log(response?.data?.data);
//     queryClient.invalidateQueries({
//       queryKey: ['patientDataReports'],
//     });
//     //navigate("/patients-lists");
//     // Show confirmation dialog
   
//   };

//     return (
//         <>
//         <div className="col-lg-8 col-xl-9">
  
//   <div className="card" id="profileSettings" style={{display:"block"}}>
//     {isLoadingPatient?(<div>Loading ...</div>):(
//     <div className="card-body">
//       <div className="border-bottom pb-3 mb-3">
//         <h5>Patient Settings</h5>
//       </div>
//       <form>
        
//         <div className="setting-title">
//           <h6>Information</h6>
//         </div>
       
//         <div className="setting-card">
//   <div className="row">

//     <div className="col-lg-4 col-md-6">
//       <div className="mb-3">
//         <label className="form-label">
//           Patient Name <span className="text-danger">*</span>
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           value={patientName}
//           onChange={(e) => setPatientName(e.target.value)}
//         />
//       </div>
//     </div>

//     <div className="col-lg-4 col-md-6">
//       <div className="mb-3">
//         <label className="form-label">
//           Age <span className="text-danger">*</span>
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           value={age}
//           onChange={(e) => setAge(e.target.value)}
//         />
//       </div>
//     </div>

//     <div className="col-lg-4 col-md-6">
//       <div className="mb-3">
//         <label className="form-label">
//           Date of Birth <span className="text-danger">*</span>
//         </label>
//         <div className="form-icon">
//           <input
//             type="date"
//             className="form-control datetimepicker"
//             placeholder="dd/mm/yyyy"
//             value={dob}
//             onChange={(e) => setDob(e.target.value)}
//           />
          
//         </div>
//       </div>
//     </div>

//     <div className="col-lg-4 col-md-6">
//       <div className="mb-3">
//         <label className="form-label">
//           Phone Number <span className="text-danger">*</span>
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           value={phone}
//           onChange={(e) => setPhone(e.target.value)}
//         />
//       </div>
//     </div>

//     <div className="col-lg-4 col-md-6">
//       <div className="mb-3">
//         <label className="form-label">
//           Email Address <span className="text-danger">*</span>
//         </label>
//         <input
//           type="email"
//           className="form-control"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//       </div>
//     </div>

//     <div className="col-lg-4 col-md-6">
//       <div className="mb-3">
//         <label className="form-label">
//           Gender <span className="text-danger">*</span>
//         </label>
//         <br />
//         <select
//           className="select form-control"
//           value={gender}
//           onChange={(e) => setGender(e.target.value)}
//         >
//           <option value="">Select</option>
//           <option value="MALE">MALE</option>
//           <option value="FEMALE">FEMALE</option>
//         </select>
//       </div>
//     </div>

//   </div>
// </div>

// <div className="setting-title">
//   <h6>Address</h6>
// </div>

// <div className="setting-card">
//   <div className="row">

//     <div className="col-lg-12">
//       <div className="mb-3">
//         <label className="form-label">
//           Address <span className="text-danger">*</span>
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           value={address}
//           onChange={(e) => setAddress(e.target.value)}
//         />
//       </div>
//     </div>

//     <div className="col-md-6">
//       <div className="mb-3">
//         <label className="form-label">
//           City <span className="text-danger">*</span>
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           value={city}
//           onChange={(e) => setCity(e.target.value)}
//         />
//       </div>
//     </div>

//     <div className="col-md-6">
//       <div className="mb-3">
//         <label className="form-label">
//           Pincode <span className="text-danger">*</span>
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           value={pincode}
//           onChange={(e) => setPincode(e.target.value)}
//         />
//       </div>
//     </div>

//   </div>
// </div>

//         <div className="modal-btn text-end">
//           {/* <a> */}
//           <button onClick={(e) => {
//     e.preventDefault();
//   }} className="btn btn-md btn-light rounded-pill">Cancel</button>
//           <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill" onClick={handleSubmit}>Save Changes</button>
//         </div>
//       </form>
//     </div>)}
//   </div>
  
// </div>

//         </>
//     );
// }
// export default PatientSettings;
import React, { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import AppointmentListService from "./Services/AppointmentListService";
import Swal from "sweetalert2";

const PatientSettings = () => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const patientId = location.state?.patientId;

  const updatedBy = localStorage.getItem("userId");
  const through = localStorage.getItem("userType");

  // Load external scripts
  useEffect(() => {
    const scriptUrls = [
      "assets/js/jquery-3.7.1.min.js",
      "assets/js/bootstrap.bundle.min.js",
      "assets/plugins/select2/js/select2.min.js",
      "assets/js/moment.min.js",
      "assets/js/bootstrap-datetimepicker.min.js",
      "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
      "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
      "assets/js/script.js",
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;
        await new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = url;
          script.async = false;
          script.onload = () => resolve();
          script.onerror = () => reject();
          document.body.appendChild(script);
        });
      }

      if (!isCancelled && window.$ && typeof window.$.fn.datetimepicker === "function") {
        window.$(".datetimepicker").datetimepicker();
      }
    };

    loadScriptsSequentially();

    return () => { isCancelled = true; };
  }, []);

  // Fetch patient data
  const { data: patientData, isLoading: isLoadingPatient } = useQuery({
    queryKey: ["patientDataReports", patientId],
    queryFn: async () => {
      const response = await AppointmentListService.getPatientByPatientId(patientId);
      return response;
    },
    enabled: !!patientId,
  });

  const patientDataReports = useMemo(() => patientData?.data?.data ?? {}, [patientData]);

  // Form states
  const [patientName, setPatientName] = useState("");
  const [gender, setGender] = useState("");
  const [phone, setPhone] = useState("");
  const [age, setAge] = useState("");
  const [dob, setDob] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");

  const [formErrors, setFormErrors] = useState({});
  const [ageMismatchWarning, setAgeMismatchWarning] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Populate form
  useEffect(() => {
    if (patientDataReports) {
      setPatientName(patientDataReports.patientName || "");
      setGender(patientDataReports.gender || "");
      setPhone(patientDataReports.phone || "");
      setAge(patientDataReports.age || "");
      setDob(patientDataReports.dob || "");
      setEmail(patientDataReports.email || "");
      setAddress(patientDataReports.address || "");
      setCity(patientDataReports.city || "");
      setPincode(patientDataReports.pincode || "");
    }
  }, [patientDataReports]);

// Calculate age from DOB
  const calculateAgeFromDOB = (dobStr) => {
    if (!dobStr) return "";
    try {
      const birthDate = new Date(dobStr);
      if (isNaN(birthDate.getTime())) return "";
      const today = new Date();
      let ageYears = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        ageYears--;
      }
      return ageYears >= 0 && ageYears <= 120 ? ageYears.toString() : "";
    } catch {
      return "";
    }
  };

  // Approximate DOB from age (using Jan 1st of the year)
  const approximateDOBFromAge = (ageStr) => {
    if (!ageStr || !/^\d+$/.test(ageStr)) return "";
    const ageNum = Number(ageStr);
    if (ageNum < 0 || ageNum > 120) return "";
    const currentYear = new Date().getFullYear();
    const birthYear = currentYear - ageNum;
    return `${birthYear}-01-01`; // approximation - user can correct day/month
  };

  // Track previous values to prevent infinite update loops
  const [prevDob, setPrevDob] = useState(dob);
  const [prevAge, setPrevAge] = useState(age);

  // DOB changed → update age
  useEffect(() => {
    if (dob === prevDob) return; // prevent loop

    const computedAge = calculateAgeFromDOB(dob);
    if (computedAge && computedAge !== age) {
      setAge(computedAge);
      setAgeMismatchWarning(false);
    } else if (age && computedAge && Math.abs(Number(age) - Number(computedAge)) > 1) {
      setAgeMismatchWarning(true);
    }

    setPrevDob(dob);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dob]);

  // Age changed → update DOB (approximation)
  useEffect(() => {
    if (age === prevAge) return; // prevent loop

    if (age && /^\d+$/.test(age)) {
      const approximatedDob = approximateDOBFromAge(age);
      if (approximatedDob && approximatedDob !== dob) {
        setDob(approximatedDob);
        setAgeMismatchWarning(false);
      }
    }
    
    setPrevAge(age);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [age]);

 

  // Validate form
  const validateForm = () => {
    const errors = {};

    // Patient Name
    if (!patientName.trim()) {
      errors.patientName = "Patient name is required.";
    } else if (patientName.length > 30) {
      errors.patientName = "Name cannot be longer than 30 characters.";
    } else if (!/^[a-zA-Z\s]+$/.test(patientName.trim())) {
      errors.patientName = "Name can only contain letters and spaces.";
    }

    // DOB
    if (!dob) {
      errors.dob = "Date of Birth is required.";
    }

    // Gender
    if (!gender) {
      errors.gender = "Gender is required.";
    }

    // Address
    if (!address.trim()) {
      errors.address = "Address is required.";
    }

    // Age
    if (!age.trim()) {
      errors.age = "Age is required.";
    } else if (!/^\d+$/.test(age)) {
      errors.age = "Age must be a number.";
    } else {
      const ageNum = Number(age);
      if (ageNum < 0 || ageNum > 120) {
        errors.age = "Age must be between 0 and 120.";
      }
    }

    // Phone (optional but format check)
    if (phone && !/^\d{10}$/.test(phone)) {
      errors.phone = "Phone number must be exactly 10 digits.";
    }

    // Pincode (optional)
    if (pincode && !/^\d{6}$/.test(pincode)) {
      errors.pincode = "Pincode must be exactly 6 digits.";
    }

    // Email (optional)
    if (email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        errors.email = "Invalid email format.";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSaving(true);

    try {
      const payload = {
        patientName,
        gender,
        phone,
        age,
        dob,
        address,
        city,
        pincode,
        email,
        through,
        updatedBy,
      };

      await AppointmentListService.changePatientDetails(patientId, payload);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Patient details updated successfully!",
      });

      queryClient.invalidateQueries({ queryKey: ["patientDataReports", patientId] });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to update patient details.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="col-lg-8 col-xl-9">
      <div className="card" id="profileSettings">
        {isLoadingPatient ? (
          <div className="card-body">Loading patient data...</div>
        ) : (
          <div className="card-body">
            <div className="border-bottom pb-3 mb-3">
              <h5>Patient Settings</h5>
            </div>

            <form onSubmit={handleSubmit} noValidate>
              <div className="setting-title">
                <h6>Basic Information</h6>
              </div>

              <div className="setting-card">
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Patient Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${formErrors.patientName ? "is-invalid" : ""}`}
                        value={patientName}
                        maxLength={30}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^[a-zA-Z\s]*$/.test(val)) {
                            setPatientName(val);
                            if (formErrors.patientName) setFormErrors({ ...formErrors, patientName: null });
                          }
                        }}
                      />
                      {formErrors.patientName && (
                        <div className="invalid-feedback">{formErrors.patientName}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
    <div className="mb-3">
      <label className="form-label">
        Age <span className="text-danger">*</span>
      </label>
      <input
        type="text"
        className={`form-control ${formErrors.age ? "is-invalid" : ""}`}
        value={age}
        maxLength={3}
        onChange={(e) => {
          const val = e.target.value;
          if (/^\d{0,3}$/.test(val)) {    // 0–3 digits
            setAge(val);
            if (formErrors.age) setFormErrors({ ...formErrors, age: null });
          }
        }}
        placeholder="Enter age"
      />
      {formErrors.age && (
        <div className="invalid-feedback">{formErrors.age}</div>
      )}
      {ageMismatchWarning && !formErrors.age && (
        <small className="text-warning d-block mt-1">
          Age doesn't match the selected date of birth (you can edit either field)
        </small>
      )}
    </div>
  </div>
                  <div className="col-lg-4 col-md-6">
    <div className="mb-3">
      <label className="form-label">
        Date of Birth <span className="text-danger">*</span>
      </label>
      <input
        type="date"
        className={`form-control ${formErrors.dob ? "is-invalid" : ""}`}
        value={dob}
        onChange={(e) => {
          setDob(e.target.value);
          if (formErrors.dob) setFormErrors({ ...formErrors, dob: null });
        }}
      />
      {formErrors.dob && <div className="invalid-feedback">{formErrors.dob}</div>}
      {dob && (
        <small className="text-muted d-block mt-1">
          Changing DOB will update Age automatically
        </small>
      )}
    </div>
  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Gender <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-control ${formErrors.gender ? "is-invalid" : ""}`}
                        value={gender}
                        onChange={(e) => {
                          setGender(e.target.value);
                          if (formErrors.gender) setFormErrors({ ...formErrors, gender: null });
                        }}
                      >
                        <option value="">Select gender</option>
                        <option value="MALE">Male</option>
                        <option value="FEMALE">Female</option>
                        <option value="OTHERS">Others</option>
                      </select>
                      {formErrors.gender && <div className="invalid-feedback">{formErrors.gender}</div>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className={`form-control ${formErrors.phone ? "is-invalid" : ""}`}
                        value={phone}
                        maxLength={10}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d*$/.test(val)) {
                            setPhone(val);
                            if (formErrors.phone) setFormErrors({ ...formErrors, phone: null });
                          }
                        }}
                      />
                      {formErrors.phone && <div className="invalid-feedback">{formErrors.phone}</div>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        className={`form-control ${formErrors.email ? "is-invalid" : ""}`}
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          if (formErrors.email) setFormErrors({ ...formErrors, email: null });
                        }}
                      />
                      {formErrors.email && <div className="invalid-feedback">{formErrors.email}</div>}
                    </div>
                  </div>
                </div>
              </div>

              <div className="setting-title">
                <h6>Address Details</h6>
              </div>

              <div className="setting-card">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${formErrors.address ? "is-invalid" : ""}`}
                        value={address}
                        onChange={(e) => {
                          setAddress(e.target.value);
                          if (formErrors.address) setFormErrors({ ...formErrors, address: null });
                        }}
                      />
                      {formErrors.address && <div className="invalid-feedback">{formErrors.address}</div>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">City</label>
                      <input
                        type="text"
                        className="form-control"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Pincode</label>
                      <input
                        type="text"
                        className={`form-control ${formErrors.pincode ? "is-invalid" : ""}`}
                        maxLength={6}
                        value={pincode}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d*$/.test(val)) {
                            setPincode(val);
                            if (formErrors.pincode) setFormErrors({ ...formErrors, pincode: null });
                          }
                        }}
                      />
                      {formErrors.pincode && <div className="invalid-feedback">{formErrors.pincode}</div>}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-btn text-end mt-4">
                <button
                  type="button"
                  className="btn btn-md btn-light rounded-pill me-2"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-md btn-primary-gradient rounded-pill"
                  disabled={isSaving}
                >
                  {isSaving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientSettings;